import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange, onReset }) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'striker', label: 'Strikers' },
    { value: 'midfielder', label: 'Midfielders' },
    { value: 'defender', label: 'Defenders' },
    { value: 'goalkeeper', label: 'Goalkeepers' },
    { value: 'coach', label: 'Coaches & Technical Staff' }
  ];

  const leagueOptions = [
    { value: 'all', label: 'All Leagues' },
    { value: 'premier-league', label: 'Premier League' },
    { value: 'la-liga', label: 'La Liga' },
    { value: 'bundesliga', label: 'Bundesliga' },
    { value: 'serie-a', label: 'Serie A' },
    { value: 'ligue-1', label: 'Ligue 1' },
    { value: 'championship', label: 'Championship' }
  ];

  const yearOptions = [
    { value: 'all', label: 'All Years' },
    { value: '2026', label: '2026' },
    { value: '2025', label: '2025' },
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: '2022', label: '2022' }
  ];

  const sortOptions = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'value-high', label: 'Highest Transfer Value' },
    { value: 'growth-high', label: 'Highest Career Growth' },
    { value: 'featured', label: 'Featured Stories' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-md p-4 md:p-5 lg:p-6 mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-4">
        <h2 className="text-lg md:text-xl font-bold text-foreground font-headline flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Filter Success Stories
        </h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          Reset Filters
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          label="Destination League"
          options={leagueOptions}
          value={filters?.league}
          onChange={(value) => onFilterChange('league', value)}
        />

        <Select
          label="Year"
          options={yearOptions}
          value={filters?.year}
          onChange={(value) => onFilterChange('year', value)}
        />

        <Select
          label="Sort By"
          options={sortOptions}
          value={filters?.sort}
          onChange={(value) => onFilterChange('sort', value)}
        />
      </div>
      <div className="mt-4">
        <Input
          type="search"
          placeholder="Search by player name, club, or achievement..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default FilterBar;